// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 999;
  display: none;
}

.message {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 20%;
  font-family: "Lexend Deca", sans-serif;
  transform: translate(-50%, -50%);
  z-index: 1000;
  display: none;
  /* Oculto por defecto */
}

.message-container {
  background-color: var(--color-white-main);
  margin: 10px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  color: #333;
  width: 100%;
  max-width: 400px;
  text-align: center;
}

.message .message-header {
  padding: 10px;
  background-color: var(--color-blue-dark);
  border-radius: 10px 10px 0px 0px;
}

.message .message-header h3 {
  font-size: 24px;
  color: var(--color-white-main);
}

.message .message-body {
  padding: 15px;
  font-size: 14px;
}

.message .message-actions {
  padding: 5px 0px;
}

.message .accept-button {
  background-color: var(--color-blue-dark);
  color: var(--color-white-main);
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-right: 10px;
  margin-bottom: 10px;
  font-family: "Lexend Deca", sans-serif;
}

.message .cancel-button {
  background-color: var(--color-blue-dark);
  color: var(--color-white-main);
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-bottom: 10px;
  font-family: "Lexend Deca", sans-serif;
}

.message button.close-button {
  background: none;
  border: none;
  color: var(--color-text-dark);
  font-size: 16px;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  padding: 1px;
  font-weight: 700;
  font-family: "Lexend Deca", sans-serif;
}

.simple-message-container {
  background-color: rgba(0, 0, 0, 0.2);
  color: var(--color-white-main);
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  text-align: center;
  font-family: "Lexend Deca", sans-serif;
}

.simple-message-container button.close-button {
  color: var(--color-white-main);
  font-size: 16px;
  position: absolute;
  top: 5px;
  right: 10px;
  cursor: pointer;
  font-family: "Lexend Deca", sans-serif;
}

@media only screen and (max-width: 600px) {
  .message {
    width: 60%;
    padding: 20px;
  }
}

@media only screen and (min-width: 601px) and (max-width: 1024px) {
  .message {
    width: 50%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/message/Message.css"],"names":[],"mappings":"AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,UAAU;EACV,sCAAsC;EACtC,gCAAgC;EAChC,aAAa;EACb,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;EACzC,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":["@import url(\"../../App.css\");\n\n.message-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.6);\n  z-index: 999;\n  display: none;\n}\n\n.message {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  width: 20%;\n  font-family: \"Lexend Deca\", sans-serif;\n  transform: translate(-50%, -50%);\n  z-index: 1000;\n  display: none;\n  /* Oculto por defecto */\n}\n\n.message-container {\n  background-color: var(--color-white-main);\n  margin: 10px;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  color: #333;\n  width: 100%;\n  max-width: 400px;\n  text-align: center;\n}\n\n.message .message-header {\n  padding: 10px;\n  background-color: var(--color-blue-dark);\n  border-radius: 10px 10px 0px 0px;\n}\n\n.message .message-header h3 {\n  font-size: 24px;\n  color: var(--color-white-main);\n}\n\n.message .message-body {\n  padding: 15px;\n  font-size: 14px;\n}\n\n.message .message-actions {\n  padding: 5px 0px;\n}\n\n.message .accept-button {\n  background-color: var(--color-blue-dark);\n  color: var(--color-white-main);\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-right: 10px;\n  margin-bottom: 10px;\n  font-family: \"Lexend Deca\", sans-serif;\n}\n\n.message .cancel-button {\n  background-color: var(--color-blue-dark);\n  color: var(--color-white-main);\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-bottom: 10px;\n  font-family: \"Lexend Deca\", sans-serif;\n}\n\n.message button.close-button {\n  background: none;\n  border: none;\n  color: var(--color-text-dark);\n  font-size: 16px;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  cursor: pointer;\n  padding: 1px;\n  font-weight: 700;\n  font-family: \"Lexend Deca\", sans-serif;\n}\n\n.simple-message-container {\n  background-color: rgba(0, 0, 0, 0.2);\n  color: var(--color-white-main);\n  padding: 10px;\n  border-radius: 5px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1000;\n  text-align: center;\n  font-family: \"Lexend Deca\", sans-serif;\n}\n\n.simple-message-container button.close-button {\n  color: var(--color-white-main);\n  font-size: 16px;\n  position: absolute;\n  top: 5px;\n  right: 10px;\n  cursor: pointer;\n  font-family: \"Lexend Deca\", sans-serif;\n}\n\n@media only screen and (max-width: 600px) {\n  .message {\n    width: 60%;\n    padding: 20px;\n  }\n}\n\n@media only screen and (min-width: 601px) and (max-width: 1024px) {\n  .message {\n    width: 50%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
